// extracted by mini-css-extract-plugin
export default {"wholePageContainer":"styles_wholePageContainer__mDP0M","bodyContent":"styles_bodyContent__h+Wad"};